"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var EventEmitter = /** @class */ (function () {
    function EventEmitter() {
        this.listeners = {};
        this.onceListeners = {};
    }
    EventEmitter.prototype.on = function (type, listener) {
        // loud fail for other non-function values
        if (typeof listener !== 'function') {
            throw new Error(type + "-listener is not a function");
        }
        else if (typeof type !== 'string') {
            throw new Error('type is not a string');
        }
        if (!Array.isArray(this.listeners[type])) {
            this.listeners[type] = [listener];
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        }
        else if (!this.listeners[type].includes(listener)) {
            this.listeners[type].push(listener);
        }
        return this;
    };
    EventEmitter.prototype.once = function (type, listener) {
        // loud fail for other non-function values
        if (typeof listener !== 'function') {
            throw new Error(type + "-listener is not a function");
        }
        else if (typeof type !== 'string') {
            throw new Error('type is not a string');
        }
        if (!Array.isArray(this.onceListeners[type])) {
            this.onceListeners[type] = [listener];
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        }
        else if (!this.onceListeners[type].includes(listener)) {
            this.onceListeners[type].push(listener);
        }
        return this;
    };
    EventEmitter.prototype.off = function (type, listener) {
        var _this = this;
        // validate args
        if (listener !== undefined && typeof listener !== 'function') {
            throw new Error(type + "-listener must be undefined, null or function");
        }
        else if (type !== undefined && typeof type !== 'string') {
            throw new Error('type must be undefined or string');
        }
        // unsubscribe all listeners
        if (type === undefined && listener === undefined) {
            this.listeners = {};
            this.onceListeners = {};
            return this;
        }
        // unsubscribe all listeners of type
        if (listener === undefined && type !== undefined) {
            delete this.listeners[type];
            delete this.onceListeners[type];
            return this;
        }
        // determine types to remove the listener from
        var types = type === undefined
            ? Object.keys(this.listeners)
            : [type];
        var onceTypes = type === undefined
            ? Object.keys(this.onceListeners)
            : [type];
        // remove listener from target types
        types.forEach(function (t) {
            if (_this.listeners[t]) {
                // only one listener of this type
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                if (_this.listeners[t].length === 1) {
                    // and its the one we want to remove
                    if (_this.listeners[t][0] === listener) {
                        // remove the whole list
                        delete _this.listeners[t];
                    }
                }
                else {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    _this.listeners[t] = _this.listeners[t].filter(function (l) { return l !== listener; });
                }
            }
        });
        // remove listener from target onceTypes
        onceTypes.forEach(function (t) {
            if (_this.onceListeners[t]) {
                // only one listener of this type
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                if (_this.onceListeners[t].length === 1) {
                    // and its the one we want to remove
                    if (_this.onceListeners[t][0] === listener) {
                        // remove the whole list
                        delete _this.onceListeners[t];
                    }
                }
                else {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    _this.onceListeners[t] = _this.onceListeners[t].filter(function (l) { return l !== listener; });
                }
            }
        });
        return this;
    };
    EventEmitter.prototype.emit = function (type, data) {
        var handlers = this.listeners[type];
        if (handlers && handlers.length) {
            handlers.forEach(function (handler) {
                try {
                    handler(data);
                }
                catch (e) {
                    console.error(type + "-event handler threw error", e);
                }
            });
        }
        var onceHandlers = Array.isArray(this.onceListeners[type])
            ? __spreadArrays(this.onceListeners[type]) : [];
        if (onceHandlers && onceHandlers.length) {
            // unsubscribe type's once handlers immediately
            delete this.onceListeners[type];
            // invoke handlers
            onceHandlers.forEach(function (handler) {
                try {
                    handler(data);
                }
                catch (e) {
                    console.error(type + "-event onceHandler threw error", e);
                }
            });
        }
    };
    return EventEmitter;
}());
exports.EventEmitter = EventEmitter;
